import { render, staticRenderFns } from "./JiaYouGuangDongRecharge.vue?vue&type=template&id=2fb0b4c9&scoped=true"
import script from "./JiaYouGuangDongRecharge.vue?vue&type=script&lang=js"
export * from "./JiaYouGuangDongRecharge.vue?vue&type=script&lang=js"
import style0 from "./JiaYouGuangDongRecharge.vue?vue&type=style&index=0&id=2fb0b4c9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0b4c9",
  null
  
)

export default component.exports